module.exports = __webpack_public_path__ + "img/20m3.140b8319.jpg";